import { emitter } from '@/helpers/eventBusHelper'
import { DocumentEvent } from '@/enums/eventType'

export const init = () => {
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      emitter.emit(DocumentEvent.DOCUMENT_SHOW)
    } else {
      emitter.emit(DocumentEvent.DOCUMENT_HIDE)
    }
  })
}
